function filterAttrs (attrs) {
    // 过滤一些敏感参数; pid是用来标记层级和父页面pageid的，不能覆盖
    const blackKeyList = ['debug', 'token', 's']
    const urlParams = attrs || K.query.get('dchn', window.location.href)
    for (const key in urlParams) {
        if (blackKeyList.indexOf(key) > -1) {
            urlParams[key] = ''
        }
    }
    return urlParams
}

/**
 * 发送 action 打点
 * @param {Object} data 统计数据，具体参考上面的文档
 */
function sendAction (data = {}) {
    const defaultConfig = {
        ...filterAttrs(),
        label: '行为埋点',
        type: 'action'
    }
    const dchnArr = K.query.get('dchn', window.location.href)
    const dchn = dchnArr && dchnArr.split(',')[0].replace('[', '')
    if (dchn) { defaultConfig.dchn = dchn }
    Omega.trackEvent('track_event', defaultConfig.label, defaultConfig)
}

/**
 * 获取统计时的 label
 * @param {Object} eventData 事件配置
 */
function getLabel (eventData) {
    const label = eventData.omegaTrack
    if (label) {
        // 事件中配置了“统计标识”，优先使用
        return label
    }
    const refId = eventData.refId
    if (!refId) {
        // 没有组件 id （特殊情况，因为 eventData 就是通过 refId 找到的）
        return ''
    }
    const refElem = document.getElementById(refId)
    if (!refElem) {
        // 根据 id 没有找到 DOM 节点（特殊情况）
        return ''
    }
    const text = refElem.textContent
    if (text) {
        // 使用元素文本内容作为 label （如 文本组件 按钮组件）
        return text
    }
    const dataset = refElem.dataset || {}
    const type = dataset.type
    if (type) {
        // 使用元素 data-type 作为 label （如 图片组件）
        return type
    }
    // 其他情况，返回空
    return ''
}

/**
 * 事件统计打点
 * @param {Object} eventData 事件配置，格式参考调用方的文档
 * @param {Object} ext 附加信息
 */
export default function (eventData = {}, ext = {}) {
    const id = eventData.refId
    if (!id) {
        // 没有 id 直接放弃
        return
    }
    const label = getLabel(eventData)
    const cat = eventData.eventName
    const type = eventData.action

    // 发送打点
    sendAction({
        id,
        label,
        cat,
        type,
        ext
    })
}
